<div class="schema-form-slide slide" [ngClass]="{'has-on-title-click': hasOnTitleClick}" (click)="onTitleClick()">
    <a [id]="slideNumber"></a>
    <div class="opener"
        [ngClass]="{'opener--completed': slideCompleted === true, 'ui-accordion-header-active' : active === true}">
        <span class="num" [ngClass]="{last: finalSlide === true }">{{slideNumber}}<i class="fa fa-check"
                aria-hidden="true"></i></span>
        <h1>{{title}}</h1>
        <p>{{supportingText}}</p>
    </div>
</div>
<div class="slide" *ngIf="active === true">
    <!-- schema form body goes here -->
    <ng-content></ng-content>
</div>
